// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"a7e25878","212":"8816467f","295":"4cd855e3","453":"b6672c60","761":"08ce41ee","777":"9de5e042"}[chunkId] + ".chunk.js";
};